(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soar-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.soar-pdp-faq [data-soar-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      head.closest('[data-soar-acc]').classList.toggle('is-open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soar-pdp-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.soar-pdp-specs [data-soar-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      head.closest('[data-soar-acc]').classList.toggle('is-open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soar-pdp-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-soar-ts]').forEach(function (root) {
    var track = root.querySelector('[data-soar-ts-track]');
    var slides = root.querySelectorAll('[data-soar-ts-slide], .soar-pdp-ts__slide');
    var current = root.querySelector('[data-soar-ts-current]');
    var prev = root.querySelector('[data-soar-ts-prev]');
    var next = root.querySelector('[data-soar-ts-next]');
    if (!track) return;

    function step() {
      var first = track.querySelector('.soar-pdp-ts__slide');
      if (!first) return 320;
      return first.getBoundingClientRect().width + 20;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', function () {
      if (!current || !slides.length) return;
      var idx = Math.round(track.scrollLeft / step()) + 1;
      current.textContent = Math.min(Math.max(idx, 1), slides.length);
    }, { passive: true });

    root.querySelectorAll('[data-soar-ts-card]').forEach(function (card) {
      var btn = card.querySelector('[data-soar-ts-play]');
      var video = card.querySelector('[data-soar-ts-video]');
      if (!btn || !video) return;
      function play() {
        root.querySelectorAll('[data-soar-ts-card].is-playing').forEach(function (c) {
          if (c !== card) { c.classList.remove('is-playing'); var v = c.querySelector('video'); if (v) { v.pause(); v.controls = false; } }
        });
        card.classList.add('is-playing');
        video.controls = true;
        video.play();
      }
      btn.addEventListener('click', function (e) { e.stopPropagation(); play(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
